import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import config from '../../../config';
import { ExternalLink } from '../../../components';

import css from './AppSection.module.css';

const AppSection = (props) => {
  const { className, headingClassName, headingText } = props;
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <h2 className={headingClassName}>{headingText}</h2>
      <ExternalLink className={css.link} href={config.custom.appStoreLink}>
        <img
          className={css.appStore}
          src="https://storage.googleapis.com/swimmy-assets/Download_on_the_App_Store_Badge_FRCA_RGB_blk.svg.png"
        />
      </ExternalLink>
      <ExternalLink className={css.link} href={config.custom.playStoreLink}>
        <img
          className={css.playStore}
          src="https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png"
        />
      </ExternalLink>
    </div>
  );
};

AppSection.defaultProps = {
  className: null,
};

AppSection.propTypes = {
  className: string,
  headingClassName: string.isRequired,
  headingText: string.isRequired,
};

export default AppSection;
